import { render } from "./OrderDetailDialog.vue?vue&type=template&id=04d39f6c"
import script from "./OrderDetailDialog.vue?vue&type=script&lang=js"
export * from "./OrderDetailDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__